module.exports = __webpack_public_path__ + "static/media/fan.798d27df.svg";